import {
  BLACK,
  RED,
  legalMoves,
  applyMove,
  evaluate
} from './xiangqiEngine';

/*
 * 1~10级AI。
 *
 * 难度不是简单增加搜索层数：
 * 低级会主动从次优着中选择；
 * 中级逐渐减少随机性；
 * 高级增加搜索深度，并优先分析强着。
 */

const CONFIG={
  1:{depth:1,pool:8,noise:160},
  2:{depth:1,pool:6,noise:110},
  3:{depth:1,pool:4,noise:70},
  4:{depth:2,pool:4,noise:50},
  5:{depth:2,pool:3,noise:30},
  6:{depth:2,pool:2,noise:18},
  7:{depth:3,pool:2,noise:12},
  8:{depth:3,pool:1,noise:6},
  9:{depth:3,pool:1,noise:2},
  10:{depth:4,pool:1,noise:0}
};

function quickScore(board,move){
  return evaluate(
    applyMove(board,move)
  );
}

/*
 * 高层搜索时先把看起来较好的走法放前面。
 * 这样Alpha-Beta更容易提前剪枝。
 */
function orderedMoves(board,turn,maxCount){
  const moves=legalMoves(board,turn);

  if(moves.length<=1)return moves;

  const sorted=moves
    .map(m=>({
      m,
      v:quickScore(board,m)
    }))
    .sort((a,b)=>
      turn===BLACK
        ?b.v-a.v
        :a.v-b.v
    )
    .map(x=>x.m);

  if(
    maxCount&&
    sorted.length>maxCount
  ){
    return sorted.slice(0,maxCount);
  }

  return sorted;
}

function search(
  board,
  depth,
  alpha,
  beta,
  maximizing,
  rootLevel
){
  if(depth<=0){
    return evaluate(board);
  }

  const turn=maximizing?BLACK:RED;

  /*
   * 10级搜索4层时控制分支数量，
   * 避免手机浏览器一次思考太久。
   */
  const limit=
    rootLevel>=10&&depth>=2
      ?14
      :rootLevel>=9&&depth>=2
      ?18
      :0;

  const moves=orderedMoves(
    board,
    turn,
    limit
  );

  if(!moves.length){
    return maximizing
      ?-999999
      :999999;
  }

  if(maximizing){
    let value=-Infinity;

    for(const move of moves){
      value=Math.max(
        value,
        search(
          applyMove(board,move),
          depth-1,
          alpha,
          beta,
          false,
          rootLevel
        )
      );

      alpha=Math.max(alpha,value);

      if(beta<=alpha)break;
    }

    return value;
  }

  let value=Infinity;

  for(const move of moves){
    value=Math.min(
      value,
      search(
        applyMove(board,move),
        depth-1,
        alpha,
        beta,
        true,
        rootLevel
      )
    );

    beta=Math.min(beta,value);

    if(beta<=alpha)break;
  }

  return value;
}

export function chooseAiMove(board,level=1){
  const lv=Math.max(
    1,
    Math.min(10,Number(level)||1)
  );

  const cfg=CONFIG[lv];
  const moves=legalMoves(board,BLACK);

  if(!moves.length)return null;

  const scored=moves
    .map(move=>{
      let value=search(
        applyMove(board,move),
        cfg.depth-1,
        -Infinity,
        Infinity,
        false,
        lv
      );

      /*
       * 低等级加入判断误差。
       * 等级越高误差越小；
       * 10级完全不加入随机误差。
       */
      if(cfg.noise){
        value+=
          (Math.random()*2-1)*
          cfg.noise;
      }

      return {
        move,
        value
      };
    })
    .sort((a,b)=>b.value-a.value);

  /*
   * 低级不会永远走评分最高的一步。
   * pool随等级提高逐渐缩小到1。
   */
  const pool=Math.min(
    cfg.pool,
    scored.length
  );

  const pick=
    pool<=1
      ?0
      :Math.floor(Math.random()*pool);

  return scored[pick].move;
}
